import { useMemo } from "react";

import { useLeavesQuery } from "@/graphql/generated";

export function usePathLabels(enabled: boolean) {
  const { data } = useLeavesQuery(undefined, { enabled });
  const labels = useMemo(
    () => new Map((data?.leaves ?? []).map((l) => [l.path, l.label])),
    [data],
  );
  return (path: string) => labels.get(path) ?? path;
}
